import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/manage-config/sysParameter';
const list = () => {
	return Client.get('/admin/api/profile-print-option');
};
const listCloud = (merchantId, branchId) => {
	return Client.get(
		`${numbatUrl}/${merchantId}/${branchId}/profile/print-option`
	);
};

const update = (payload) => {
	return Client.put('/admin/api/profile-print-option', payload);
};
const updateCloud = (merchantId, branchId, payload) => {
	return Client.put(
		`${numbatUrl}/${merchantId}/${branchId}/profile/print-option`,
		payload
	);
};

export default {
	list,
	update,
	listCloud,
	updateCloud,
};
